import { render, staticRenderFns } from "./IconInfo.vue?vue&type=template&id=25351948&scoped=true"
import script from "./IconInfo.vue?vue&type=script&lang=js"
export * from "./IconInfo.vue?vue&type=script&lang=js"
import style0 from "./IconInfo.vue?vue&type=style&index=0&id=25351948&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25351948",
  null
  
)

export default component.exports